import { render, staticRenderFns } from "./profileCard.vue?vue&type=template&id=6670a02a"
import script from "./profileCard.vue?vue&type=script&lang=js"
export * from "./profileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports